import React from 'react';
import { Container, Button } from 'reactstrap';

const InviteReqConfirmationPageContent = () => {
    return (
        <Container className="text-center">
            <p style={{ fontSize: '0.85rem' }}>
                You will receive an email from your Portal Admin with next steps.
            </p>
            <p style={{ fontSize: '0.85rem' }}>
                Please contact your portal Admin directly for additional assistance.
            </p>
            <Button color="primary">CLOSE</Button>
        </Container>
    )
};
export default InviteReqConfirmationPageContent;